import {
    PlayCircleIcon,
    SparklesIcon,
    WifiIcon,
    CpuChipIcon,
    LockClosedIcon,
    HeartIcon,
    BoltIcon,
    StarIcon,
    UserIcon,
} from '@heroicons/react/24/solid';

// --- Definición de Categorías para Meditaciones ---
export const MeditationCategories = {
    MindRewire: {
        id: 'MIND_REWIRE',
        title: 'Mind & Neural Rewiring',
        Icon: CpuChipIcon,
        iconColor: 'text-purple-400',
    },
    FrequencyAlignment: {
        id: 'FREQUENCY_ALIGNMENT',
        title: 'Frequency Alignment',
        Icon: SparklesIcon,
        iconColor: 'text-sky-400',
    },
    EmotionalHealing: {
        id: 'EMOTIONAL_HEALING',
        title: 'Emotional Healing',
        Icon: HeartIcon,
        iconColor: 'text-rose-400',
    },
    SoundsAndMusic: {
        id: 'SOUND_AND_MUSIC',
        title: 'Sound & Music',
        Icon: PlayCircleIcon,
        iconColor: 'text-pink-400',
    },
    GalacticSymbols: {
        id: 'GALACTIC_SYMBOLS',
        title: 'Galactic Symbols',
        Icon: UserIcon,
        iconColor: 'text-green-400',
    },
    Holotropic: {
        id: 'HOLOTROPIC',
        title: 'Holotropic Meditations',
        Icon: StarIcon,
        iconColor: 'text-green-400',
    },
};

export const DeepCosmicMeditation = {
  category: MeditationCategories.FrequencyAlignment,
  title: "Deep Cosmic Exploration Meditation",
  description: "Embark on a profound journey of self-discovery and cosmic exploration with this powerful guided meditation from Bashar. Delve into the five fundamental laws of creation and unlock your innate power to shape your reality.",
  type: 'youtube',
  youtubeId: "2Y55ItaRtPk",
  Icon: SparklesIcon,
  iconColor: "text-green-400",
  requiresAuth: false
};

// --- Lista de Meditaciones (con el objeto categoría completo) ---
export const meditationData = [
    {
        category: MeditationCategories.FrequencyAlignment,
        title: "11:11 Meditation: Connect with Your Best Parallel Reality Self",
        description: "A powerful meditation to align with the version of yourself that is already living your desired reality. Use the 11:11 gateway to synchronize your frequencies.",
        type: 'youtube',
        youtubeId: "WyGAmrMd9E4",
        Icon: SparklesIcon, // Icono específico de la meditación (puede ser diferente al de la categoría)
        iconColor: "text-sky-400",
        requiresAuth: false
    },
    {
        category: MeditationCategories.MindRewire,
        title: "Meditation for Rewiring Neural Pathways",
        description: "This guided session is designed to help you create new, empowering neural connections, breaking old patterns and fostering positive mental habits.",
        type: 'youtube',
        youtubeId: "i9l8fzHWipY",
        Icon: CpuChipIcon,
        iconColor: "text-purple-400",
        requiresAuth: false
    },
    {
        category: MeditationCategories.GalacticSymbols,
        title: "Sacred Ancestral Circuits from Other Galactic Civilizations",
        description: "An ancient technique shared to rewire your mind using sacred geometric patterns and frequencies from advanced galactic civilizations.",
        type: 'youtube',
        youtubeId: "xHZAfb9FE8Q",
        Icon: WifiIcon,
        iconColor: "text-pink-400",
        requiresAuth: true
    },
    {
        category: MeditationCategories.EmotionalHealing,
        title: "Beethoven's 7th Symphony (Movement 2) Grief Release Loop",
        description: "As recommended by Bashar, this 3-minute loop of Beethoven's masterpiece can help you process and release grief, sadness, and elevate your frequency.",
        type: 'youtube',
        youtubeId: "FKNg-A6Y5Aw",
        Icon: PlayCircleIcon,
        iconColor: "text-yellow-400",
        requiresAuth: false
    },
    {
        category: MeditationCategories.Holotropic,
        title: "Gamma Holotropic Meditation",
        description: "A powerful holotropic meditation from Bashar to activate your gamma state and expand your consciousness. This is an exclusive session for our members.",
        type: 'mp4',
        videoUrl: "https://gusaguiar.com/assets/gamma-activation-kit/Bashar - Gamma Holotropic Meditation.mp4",
        Icon: PlayCircleIcon, // Usamos LockClosedIcon para denotar exclusividad
        iconColor: "text-green-400",
        requiresAuth: true
    },
    DeepCosmicMeditation,
];